import { IChainInfo } from '@kattana-io/common';
import { defer, LoaderFunctionArgs } from 'react-router-dom';
import { KattanaAPI } from '../../store/createStore';

export type chainPageLoaderDataType = IChainInfo | null;

const chainPageLoader = async ({ params, request }: LoaderFunctionArgs) => {
  const chain = params.chain || '';

  const data = KattanaAPI.chainInfo(chain, { signal: request.signal });

  return defer({ chain: data });
};

export default chainPageLoader;
